import styled, { css } from "styled-components";
import { getColor, getSize } from "~/helpers/style";
import { UIProps } from "~/types/style";

interface IPlanCard extends UIProps {
  primary?: boolean;
  active?: boolean;
  onClick?: () => void;
  isLaptop?: boolean;
}

export const PlanCardContainer = styled.a<IPlanCard>`
  align-items: baseline;
  min-width: 158px;
  width: 100%;
  min-height: 163px;
  position: relative;
  height: auto;
  cursor: pointer;
  padding: 20px 10px;
  border-radius: 6px;

  ${({ active }) =>
    active
      ? css`
          opacity: 1;
          border: ${getSize(0.3)} solid ${getColor("primary")};
        `
      : css`
          opacity: 0.6;
          border: 1px solid ${getColor("disabled")};
          &:hover {
            border: 1.8px solid ${getColor("primary")};
          }
        `}
`;

export const PlanCardPromotion = styled.div<{ isHighlighted: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  border-radius: 2px 2px 0 0;
  padding: 2px 0;
  font-weight: 500;
  height: 20px;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${getColor("primary")};
      color: ${getColor("white")};
    `}
`;

export const PlanCardTitle = styled.h2<IPlanCard>`
  font-size: 12px;
  margin: 0;
  position: relative;

  ${({ active }) =>
    active
      ? css`
          font-weight: 600;
        `
      : css`
          font-weight: 500;
        `}
`;

export const PlanCardPrice = styled.h3<IPlanCard>`
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: ${getSize(0.5)};

  sub {
    margin-top: -10px;
    font-size: 9px;
    font-weight: 400;
  }

  ${({ active }) =>
    active
      ? css`
          color: ${getColor("primary")};
        `
      : css`
          color: ${getColor("black")};
        `}
`;

export const MonthsOffText = styled.span`
  font-size: 10px;
  font-weight: 700;
`;

export const MostPopularText = styled.span`
  color: ${getColor("white")};
  font-size: 10px;
  font-weight: 700;
`;

export const DiscountText = styled.span`
  width: max-content;
  color: ${getColor("textSecondary")};
  opacity: 0.5;
  text-decoration: line-through;
  margin-right: ${getSize(0.6)};
`;

export const MonthlyValue = styled.span`
  color: ${getColor("textSecondary")};
  font-size: 12px;
  font-weight: 500;
`;

export const PlanCardList = styled.div<IPlanCard>`
  display: grid;
  grid-template-columns: "repeat(1, 1fr)";
  gap: 12px;
  margin-top: 12px;
`;

export const PlanCardItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${getSize(1.2)};
  font-family: Inter;
  font-size: 11px;
  line-height: 14.52px;
`;

export const RadioPlanName = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
